import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Preview } from './components/Preview';
import { PainPoints } from './components/PainPoints';
import { Audience } from './components/Audience';
import { Stats } from './components/Stats';
import { ContentTomos } from './components/ContentTomos';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { EliteUpsell } from './components/EliteUpsell';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Scarcity } from './components/Scarcity';
import { Footer } from './components/Footer';
export function App() {
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'elite' | 'completo'>('completo');
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-teal-100 selection:text-teal-900" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <Preview data-id="element-3" />
      <PainPoints data-id="element-4" />
      <Audience data-id="element-5" />
      <Stats data-id="element-6" />
      <ContentTomos data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Comparison data-id="element-9" />
      <Pricing selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} data-id="element-10" />
      <EliteUpsell data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <Scarcity selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}